import { useSelector } from 'react-redux'

import {
  selectCurrentVariantCohortToUse,
  selectLanguage,
} from 'root-redux/selects/common'

import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'

import {
  AUTO_BUNDLE_UPSELL_LOCALES_BY_COHORT,
  AUTO_BUNDLE_UPSELL_PAGES,
} from 'modules/purchase/constants'

import { PageId } from 'page-constants'
import { Cohort, Language } from 'root-constants'

export const useIsAutoBundleUpsell = (pageId: PageId): boolean => {
  const cohortToUse = useSelector(selectCurrentVariantCohortToUse)
  const language = useSelector(selectLanguage)
  const { isAyah110MonthlyUpsellTest } = useExperimentalFeatures()

  if (!AUTO_BUNDLE_UPSELL_PAGES.includes(pageId)) {
    return false
  }

  if (isAyah110MonthlyUpsellTest) {
    return true
  }

  const allowedLocales =
    AUTO_BUNDLE_UPSELL_LOCALES_BY_COHORT[cohortToUse as Cohort]

  return !!allowedLocales?.includes(language as Language)
}
